import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CBadge,
  CSelect,
  CTooltip,
  CAlert,
} from "@coreui/react";
import { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { getItem, getList } from "../../api/generics";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert, successAlert, warningAlert } from "../utils/messages";
import AccountingReportLogUpdateModal from "./AccountingReportLogUpdateModal";

import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import { changeTZToUtc, formatUTCDateTime } from "../../utils/dates";

import AccountingReportLogDeleteModal from "./AccountingReportLogDeleteModal";

import AccountingReportLogEntry, {
  ACCOUNTINGREPORTSSTATUSES,
  ACCOUNTINGREPORTSTYPES,
  getAccountingReportLogStatusLabel,
  getAccountingReportLogTypeLabel,
  getccountingReportLogStatusClass,
} from "../../models/accounting-reports";
import { ACCOUNTING_ENTRIES_RETRIEVE } from "../../auth/permissions";
import { getObjectMinioUrl } from "../../minio/urls";

const ITEMS_PER_PAGE = 25;

const AccountingReportLogList = () => {
  const fields = [
    {
      key: "createdAt",
      _classes: ["text-center"],
      label: "Fecha",
    },
    {
      key: "reportType",
      _classes: ["text-center"],
      label: "Tipo",
    },
    {
      key: "status",
      _classes: ["text-center"],
      label: "Estado",
    },
    {
      key: "obs",
      _classes: ["text-center"],
      label: "Obs",
    },
    {
      key: "userName",
      _classes: ["text-center"],
      label: "Generado por",
    },

    {
      key: "reportUrl",
      _classes: ["text-center"],
      label: "Descargar",
    },
    {
      key: "actions",
      _classes: ["text-center"],
      label: "Acciones",
      filter: false,
    },
  ];

  const [showEditModal, setShowEditModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [accountingReportLog, setAccountingReportLog] = useState<
    AccountingReportLogEntry | undefined
  >(undefined);
  const [search, setSearch] = useState<string>("");
  const [startDate, setStartDate] = useState<string | moment.Moment>("");
  const [endDate, setEndDate] = useState<string | moment.Moment>("");

  const [filterStatus, setFilterStatus] = useState<string>("");
  const [filterReportType, setFilterReportType] = useState<string>("");

  const [loading, setLoading] = useState(true);

  const [accountingReportLogs, setAccountingReportLogs] = useState<
    AccountingReportLogEntry[]
  >([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let entryStatus = urlParams.get("entry_status")
      ? urlParams.get("entry_status")
      : "";
    let reportType = urlParams.get("report_type")
      ? urlParams.get("report_type")
      : "";
    let startDate = urlParams.get("start_date")
      ? urlParams.get("start_date")
      : "";
    let endDate = urlParams.get("end_date") ? urlParams.get("end_date") : "";

    let map = new Map();
    map.set("page", page);
    if (search !== "") map.set("search", search);
    if (startDate !== "") map.set("start_date", startDate);
    if (endDate !== "") map.set("end_date", endDate);

    if (entryStatus !== "") map.set("entry_status", entryStatus);
    if (reportType !== "") map.set("report_type", reportType);
    return map;
  };

  const fetchAccountingReportLogs = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    const accountingReportsStatus = await getList<AccountingReportLogEntry>(
      "/accounting_reports/",
      limit,
      offset,
      urlParams
    );
    console.log(accountingReportsStatus);
    if (accountingReportsStatus.status === SUCCESS) {
      if (accountingReportsStatus.data !== undefined) {
        const count = accountingReportsStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setAccountingReportLogs(accountingReportsStatus.data.items);
        setCurrentPage(urlParams.get("page"));
      }
    } else {
      const message = accountingReportsStatus.detail
        ? accountingReportsStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : ""
    );
    if (previousParams.get("entry_status")) {
      urlParams.set("entry_status", previousParams.get("entry_status"));
    }
    if (previousParams.get("report_type")) {
      urlParams.set("report_type", previousParams.get("report_type"));
    }
    if (previousParams.get("start_date")) {
      urlParams.set("start_date", previousParams.get("start_date"));
    }
    if (previousParams.get("end_date")) {
      urlParams.set("end_date", previousParams.get("end_date"));
    }
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onFilterStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterStatus(e.target.value);
  };

  const onFilterReportTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterReportType(e.target.value);
  };

  const onStartDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setStartDate("");
      return;
    }
    setStartDate(value);
  };

  const onEndDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setEndDate("");
      return;
    }
    setEndDate(value);
  };

  const onUpdateClick = (accountingentry: AccountingReportLogEntry) => {
    setAccountingReportLog(accountingentry);
    setShowEditModal(true);
  };

  const onEditCancel = () => {
    setAccountingReportLog(undefined);
    setShowEditModal(false);
  };

  const onEditSuccess = () => {
    successAlert("Datos guardados con éxito!");
    setShowEditModal(false);
    setAccountingReportLogs([]);
    setLoading(true);
    fetchAccountingReportLogs();
  };

  const onDeleteClick = (accountingentry: AccountingReportLogEntry) => {
    setAccountingReportLog(accountingentry);
    setShowDeleteModal(true);
  };

  const onDeleteCancel = () => {
    setAccountingReportLog(undefined);
    setShowDeleteModal(false);
  };

  const onDeleteSuccess = () => {
    successAlert("Datos eliminados con éxito!");
    setShowDeleteModal(false);
    setAccountingReportLogs([]);
    setLoading(true);
    fetchAccountingReportLogs();
  };

  const onXLSXClick = async (entry: AccountingReportLogEntry) => {
    const xlsxState = await getItem<{ url: string }>(
      `/accounting_reports/${entry.id}/file/`
    );

    if (xlsxState.status !== SUCCESS || xlsxState.data === undefined) {
      errorAlert("Error al tratar de obtener el Reporte");
      return;
    }
    window.open(getObjectMinioUrl(xlsxState.data.url), "_blank");
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    if (search !== "") {
      urlParams.set("search", search);
    } else {
      urlParams.delete("search");
    }
    if (filterStatus !== "") {
      urlParams.set("entry_status", filterStatus);
    } else {
      urlParams.delete("entry_status");
    }
    if (filterReportType !== "") {
      urlParams.set("report_type", filterReportType);
    } else {
      urlParams.delete("report_type");
    }
    if (moment.isMoment(startDate)) {
      urlParams.set("start_date", startDate.toISOString());
    } else if (startDate !== undefined && startDate !== "") {
      urlParams.set("start_date", startDate);
    } else {
      urlParams.delete("start_date");
    }
    if (moment.isMoment(endDate)) {
      urlParams.set("end_date", endDate.toISOString());
    } else if (endDate !== undefined && endDate !== "") {
      urlParams.set("end_date", endDate);
    } else {
      urlParams.delete("end_date");
    }
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  useEffect(() => {
    fetchAccountingReportLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("accountingReportsHistory")) {
        return;
      }
      fetchAccountingReportLogs();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>Reportes Contables Generados</h3>
              </div>
              <div className="p-2 "></div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="12">
                  <CAlert color="primary">
                    <h5>
                      ⚠️ Atención: Si tiene una entrada en estado "Generando..."
                      puede comprobar si ya se ha terminado de generar
                      recargando la vista usando la tecla "F5"
                    </h5>
                  </CAlert>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <h5>Filtros</h5>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Estado:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={filterStatus !== null ? filterStatus : ""}
                    onChange={onFilterStatusChange}
                  >
                    <option value={""}>-----</option>
                    {Object.entries(ACCOUNTINGREPORTSSTATUSES).map(
                      ([key, entry], ix) => {
                        return (
                          <option key={ix} value={key}>
                            {entry.name}
                          </option>
                        );
                      }
                    )}
                  </CSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Tipo Reporte:</CLabel>
                </CCol>

                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={filterStatus !== null ? filterStatus : ""}
                    onChange={onFilterReportTypeChange}
                  >
                    <option value={""}>-----</option>
                    {Object.entries(ACCOUNTINGREPORTSTYPES).map(
                      ([key, entry], ix) => {
                        return (
                          <option key={ix} value={key}>
                            {entry.name}
                          </option>
                        );
                      }
                    )}
                  </CSelect>
                </CCol>
              </CRow>

              <CRow>
                <CCol></CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Desde:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onStartDatehange}
                    value={startDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Hasta:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onEndDatehange}
                    value={endDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Concepto..."
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                    >
                      Buscar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <CDataTable
                  noItemsView={<h2 className="text-center">No se encontraron registros</h2>}
                  addTableClasses={"table-fixed"}
                  fields={fields}
                  items={accountingReportLogs}
                  striped
                  border
                  loading={loading}
                  responsive
                  scopedSlots={{
                    createdAt: (item: AccountingReportLogEntry) => {
                      return (
                        <td className="text-center">
                          {item.createdAt
                            ? formatUTCDateTime(
                                changeTZToUtc(new Date(item.createdAt))
                              )
                            : "-"}
                        </td>
                      );
                    },
                    status: (item: AccountingReportLogEntry) => {
                      return (
                        <td className="text-center">
                          <CBadge
                            color={
                              item.status
                                ? getccountingReportLogStatusClass(item.status)
                                : undefined
                            }
                          >
                            {item.status
                              ? getAccountingReportLogStatusLabel(item.status)
                              : undefined}
                          </CBadge>
                        </td>
                      );
                    },
                    reportType: (item: AccountingReportLogEntry) => {
                      return (
                        <td className="text-center">
                          {item.reportType
                            ? getAccountingReportLogTypeLabel(item.reportType)
                            : "-"}
                        </td>
                      );
                    },
                    obs: (item: AccountingReportLogEntry) => {
                      return (
                        <td className="text-center">
                          {item.obs ? item.obs : "-"}
                        </td>
                      );
                    },
                    reportUrl: (item: AccountingReportLogEntry) => {
                      let pdfButton = null;
                      if (item.reportUrl !== undefined) {
                        pdfButton = (
                          <CTooltip content="Descargar">
                            <CButton
                              className="text-white"
                              color="success"
                              onClick={() => {
                                onXLSXClick(item);
                              }}
                            >
                              <i className="fa fa-file-excel"></i>
                            </CButton>
                          </CTooltip>
                        );
                      }
                      return <td className="text-center">{pdfButton}</td>;
                    },

                    actions: (item: AccountingReportLogEntry) => {
                      const editButton = (
                        <PermissionRequiredComponent
                          permissionName={ACCOUNTING_ENTRIES_RETRIEVE}
                        >
                          <CTooltip content={"Editar"}>
                            <CButton
                              className="text-white"
                              color="warning"
                              onClick={() => {
                                onUpdateClick(item);
                              }}
                            >
                              <i className="fa fa-pencil"></i>
                            </CButton>
                          </CTooltip>
                        </PermissionRequiredComponent>
                      );

                      const deleteButton = (
                        <PermissionRequiredComponent
                          permissionName={ACCOUNTING_ENTRIES_RETRIEVE}
                        >
                          <CTooltip content={"Eliminar"}>
                            <CButton
                              className="text-white"
                              color="danger"
                              onClick={() => {
                                onDeleteClick(item);
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </CButton>
                          </CTooltip>
                        </PermissionRequiredComponent>
                      );

                      return (
                        <td className="text-right">
                          <CButtonGroup>
                            {item.status === "completed" ? editButton : null}
                          </CButtonGroup>
                          <CButtonGroup>
                            {item.status !== "generating" ? deleteButton : null}
                          </CButtonGroup>
                        </td>
                      );
                    },
                  }}
                />
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : ""}
                  />
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <AccountingReportLogUpdateModal
        show={showEditModal}
        onCancel={onEditCancel}
        onSuccess={onEditSuccess}
        accountingreportlog={accountingReportLog}
      />
      <AccountingReportLogDeleteModal
        show={showDeleteModal}
        onCancel={onDeleteCancel}
        onSuccess={onDeleteSuccess}
        accountingreportlog={accountingReportLog}
      />
    </>
  );
};

export default AccountingReportLogList;
